import {RouteRecordRaw} from "vue-router";

interface PrefixRouteRecordRaw {
  prefix: string;
  children: InputRouteRecordRaw[];
}

type InputRouteRecordRaw = RouteRecordRaw | PrefixRouteRecordRaw;

function isPrefixRoute(route: InputRouteRecordRaw): route is PrefixRouteRecordRaw {
    return !!(route as any).prefix;
}

export function formatRoutes(routes: InputRouteRecordRaw[], prefix = ''): RouteRecordRaw[] {
    const formattedRoutes: RouteRecordRaw[] = [];
    for (const route of routes) {
        if (isPrefixRoute(route)) {
            formattedRoutes.push(...formatRoutes(route.children, route.prefix + "/"))
        } else {
            route.path = prefix + route.path;
            if (route.children) {
                route.children = formatRoutes(route.children);
            }
            formattedRoutes.push(route);
        }
    }
    return formattedRoutes;
}

export function mergeRoutes(... args: InputRouteRecordRaw[][]) {
    const routes: RouteRecordRaw[] = [];
    for (const item of args) {
        routes.push(...formatRoutes(item));
    }
    return routes;
}
